import VehicleEntry from './VehicleEntry';
import {
  Background,
  BackgroundImage,
  Card,
  CardWrapper,
  Container,
  Description,
  TextContainer,
  Title
} from './HeroFold.styles';

const HeroFold = () => (
  <Background>
    <BackgroundImage />
    <Container>
      <TextContainer>
        <Title>Get a real offer in 2 minutes</Title>
        <Description>Sell or trade your car 100% online. No haggling, no headaches.</Description>
      </TextContainer>
      <CardWrapper>
        <Card>
          <VehicleEntry />
        </Card>
      </CardWrapper>
    </Container>
  </Background>
);

export default HeroFold;
